import { Box, Button, Divider } from '@mui/material'
import PageWrapper from 'hoc/PageWrapper'
import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import {
  useCreateProcurementPlanDraftMutation,
  useProcurementPlansQuery,
} from 'services/procurementPlans'
import { v4 as uuidv4 } from 'uuid'
import { Loading } from 'components/Loading'
import { ProcurementPlansCard } from './procurement-plans-card'
import { EProcurementPlanStatus } from 'types/procurementPlans'
import { startOfYesterday } from 'date-fns'
import { formattedTimeStandart } from 'hooks/date/formattedTime'

const today = new Date()

export const ProcurementPlans: FunctionComponent = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { data, isLoading } = useProcurementPlansQuery({ page: 0, size: 1000 })

  const [createProcurementPlanDraft] = useCreateProcurementPlanDraftMutation()

  const hideCreate =
    data?.some((p) => p.year === today.getFullYear()) &&
    data?.some((p) => p.year === today.getFullYear() + 1)

  const handleCreate = async () => {
    const year = data?.some((p) => p.year === today.getFullYear())
      ? today.getFullYear() + 1
      : today.getFullYear()

    const result = await createProcurementPlanDraft({
      id: uuidv4(),
      correlationId: uuidv4(),
      year: Number(year),
      status: EProcurementPlanStatus.PLANNING,
      creationOrderDate: formattedTimeStandart(startOfYesterday()),
    })

    if ('data' in result) {
      navigate(`/portal/procurement-plans/${result.data.id}/edit`)
    }
  }

  if (isLoading) {
    return <Loading />
  }

  return (
    <PageWrapper>
      <Box display="flex" justifyContent="flex-end">
        {!hideCreate && (
          <Button
            color="primary"
            variant="contained"
            style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
            onClick={handleCreate}
          >
            {t('create')}
          </Button>
        )}
      </Box>
      <Divider sx={{ my: 1.5 }} />
      {data?.map((procurementPlan) => (
        <ProcurementPlansCard
          key={procurementPlan.id}
          procurementPlan={procurementPlan}
        />
      ))}
    </PageWrapper>
  )
}
